import React, { Component } from 'react';
import PropTypes from 'prop-types';
import enhanceWithClickOutside from 'react-click-outside';

class Frame extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside() {
    this.props.onClickOutSide();
  }

  render() {
    const { children, style, className } = this.props;
    return (
      <div style={style} className={className}>
        {children}
      </div>
    );
  }
}

Frame.propTypes = {
  children: PropTypes.element,
  onClickOutSide: PropTypes.func,
  style: PropTypes.shape({}),
  className: PropTypes.string,
};
Frame.defaultProps = {
  onClickOutSide: () => {},
  children: null,
  style: {},
  className: '',
};

export default enhanceWithClickOutside(Frame);
